module.exports = __webpack_public_path__ + "logo.8eb99a2cd577a631dc4422f4da4af4eb.png";